<template>
    <quiz-container :loading="loading">
        <template slot="content">
            <h2 class="quiz-result-title">{{sentence}}</h2>
            <swiper
                class="carousel"
                ref="swiper"
                :options="swiperOptions"
                @slide-change="handleChangeSlide">
                <swiper-slide v-for="outfit in outfits" :key="outfit.outfit_id">
                    <outfit-card
                        :outfit="outfit"
                        :handleProductClk="handleVisitProduct"
                    />
                </swiper-slide>
                <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
            </swiper>
            <transition name="fade">
                <div class="quiz-overlay-modal" v-show="showRestartModal">
                    <div class="quiz-restart-modal">
                        <h3 class="quiz-restart-modal-title">Restart the Quiz?</h3>
                        <div class="quiz-restart-modal-buttons-container">
                            <button class="quiz-restart-modal-button quiz-restart-modal-button--left" @click="restartQuiz">Yes</button>
                            <button class="quiz-restart-modal-button quiz-restart-modal-button--right" @click="showRestartModal = false">No</button>
                        </div>
                    </div>
                </div>
            </transition>
        </template>
        <template slot="cta-buttons">
            <share-outfit :outfit="currentOutfit" color="white" key="share-button" />
            <button class="button pink main-button" @click.stop="goToGetStyled">See matching Outfits</button>
        </template>
        <restart-quiz-button slot="exit-button-left" @click.stop="showRestartModal = true" />
    </quiz-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
    import OutfitCard from '../style-selection/outfit-card.vue';
    import ShareOutfit from '../outfit/share-outfit.vue';
    import QuizContainer from './quiz-container.vue';
    import RestartQuizButton from './restart-quiz-button.vue';
    import { OUTFIT_TYPES } from '../../config';
    
    export default {
        components: {
            Swiper,
            SwiperSlide,
            OutfitCard,
            ShareOutfit,
            QuizContainer,
            RestartQuizButton,
        },
        data() {
            return {
                showRestartModal: false,
            };
        },
        computed: {
            swiperOptions() {
                return {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                    centeredSlides: true,
                    pagination: {
                        el: '.swiper-pagination',
                    },
                    initialSlide: this.currentOutfitIndex,
                };
            },
            loading() {
                return this.loadingOutfits || this.loadingProfile;
            },
            ...mapGetters({
                outfits: 'quizzes/outfits',
                sentence: 'quizzes/lastSentence',
                profile: 'quizzes/profile',
                quiz: 'quizzes/current',
                currentOutfit: 'quizzes/currentOutfit',
                currentOutfitIndex: 'quizzes/currentOutfitIndex',
                loadingOutfits: 'quizzes/loadingOutfits',
                loadingProfile: 'quizzes/loadingProfile',
                loadingShare: 'share/getLoadingStatus',
            }),
        },
        methods: {
            handleVisitProduct(product, outfit) {
                this.$store.commit('menu/setReturnPage', {
                    href: '/quiz/result',
                    title: 'Back to Quiz'
                });
                this.$store.commit('outfits/setCurrentOutfit', { outfit });
                this.$helpers.visitProduct(this.$router, product, { 
                    outfitId: outfit.outfit_id,
                    outfitType: OUTFIT_TYPES.QUIZ,
                });
            },
            handleChangeSlide() {
                this.$store.commit('quizzes/setCurrentOutfit', this.$refs.swiper.swiperInstance.activeIndex);
            },
            goToGetStyled() {
                if(this.quiz && this.quiz.options) {
                    this.$store.commit('filters/resetSelectedFilters');
                    this.$store.commit('filters/setSelectedFilter', {
                        optionValues: this.quiz.options.reduce((obj, optionValueId) => {
                            obj[optionValueId] =  true;
                            return obj;
                        }, {}),
                    });
                    this.$store.dispatch('filters/applyFilters');
                }
                this.$router.push({ path: '/get-styled' });
            },
            restartQuiz() {
                this.$router.push({ path: '/quiz/new' });
            },
        },
        created() {
            if(this.outfits.length === 0) {
                this.$store.dispatch('quizzes/fetchOutfits');
            }
        },
        beforeRouteLeave(to, from, next) {
            if(!to.path.includes('/quiz')) {
                this.$store.commit({
                    type: 'footer/showFooter'
                });
            }
            next();
        },
    }
</script>

<style lang="scss">
    .swiper {
        &-slide { 
            width: 80%;
            max-width: 230px;
            box-sizing: border-box;
        }

        &-pagination-bullet {
            width: 4px;
            height: 4px;
            vertical-align: middle;
            background-color: white;
            margin: 0 7.5px;

            &-active {
                width: 9px;
                height: 9px;
            }

            &s {
                width: 100%;
                margin-top: 20px;
            }
        }
    }

    .swiper-wrapper {
        height: 300px;

        @media (min-height: 669px) {
            height: 365px;
        }
    }
    
</style>

<style lang="scss" scoped>
    .swiper-container {
        height: 350px;

        @media (min-height: 669px) {
            height: 415px;
        }
    }
    
    .quiz-result-title {
        color: white;
        font-size: 16px;
        line-height: 17px;
        text-align: center;
        font-weight: normal;
        padding: 0 20px 20px;
        max-width: 600px;
        text-align: center;
        @media screen and (min-height: 740px) {
            padding: 34px 20px;
            font-size: 18px;
            line-height: 21px;
        }
    }

    .quiz-restart-modal {
        position: absolute;
        top: calc(50% - 141px);
        left: calc(50% - 131px);
        background-color: black;
        text-align: center;
        font-size: 24px;
        width: 262px;
        height: 141px;
        border: 1px solid #4A4A4A;
        border-radius: 7px;
        &-title {
            padding: 15px 52px;
            font-family: 'Lato';
            color: white;
        }
        &-buttons-container{
            display: flex;
            justify-content: center;
            width: 220px;
            margin: 0 auto;
            padding-top: 3px;
            border-top: 1px solid #979797;
        }
        &-button {
            color: white;
            width: 110px;
            height: 33px;
            font-family: 'Lato';
            font-size: 14px;
            &--left {
                border-right: 1px solid #979797;
            }
            &--right {
                border-left: 1px solid #979797;
                color: #BD0000;
            }
        }
    }

    .quiz-overlay-modal {
        height: 100vh;
        width: 100vw;
        background-color: rgba(0, 0, 0, 0.6);
        position: absolute;
        z-index: 100;
        top: 0;
        left: 0;
    }
</style>